import { Box } from "@mui/material";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import React, { useRef, useState, useEffect, useCallback } from "react";
import { FOCUS_BORDER } from "../../config/focusStyles";
import { useInputMode } from "../../utils/hooks/useInputMode";

const useMockInput = ({ onEnterPress, showCursor, isLoading, requestInit }) => {
  const [text, setText] = useState("");
  const [cursorPosition, setCursorPosition] = useState(0);
  const textRef = useRef(null);
  const [cursorLeft, setCursorLeft] = useState(0); // Tracks the cursor's left position

  // Update the cursor's absolute position
  const updateCursorPosition = (position) => {
    try {
      const container = textRef.current;
      if (container) {
        const range = document.createRange();
        const selection = window.getSelection();

        range.setStart(container.childNodes[0] || container, position);
        range.setEnd(container.childNodes[0] || container, position);

        const rects = range.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        //setCursorLeft(containerRect.right - rects.right);
        selection.removeAllRanges();
      }
    } catch (error) { }
  };

  // Add a character at the current cursor position
  const addCharacter = (char) => {
    const beforeCursor = text.slice(0, cursorPosition);
    const afterCursor = text.slice(cursorPosition);
    const newText = beforeCursor + char + afterCursor;

    setText(newText);
    const newPosition = cursorPosition + 1;
    setCursorPosition(newPosition);
    updateCursorPosition(newPosition);
  };

  // Remove a character before the current cursor position
  const removeCharacter = () => {
    if (cursorPosition > 0) {
      const beforeCursor = text.slice(0, cursorPosition - 1);
      const afterCursor = text.slice(cursorPosition);
      const newText = beforeCursor + afterCursor;

      const newPosition = cursorPosition - 1;
      setText(newText);
      setCursorPosition(newPosition);
      updateCursorPosition(newPosition);
    }
  };

  // Move the cursor position left or right
  const moveCursor = (direction) => {
    const newPosition =
      direction === "left"
        ? Math.max(0, cursorPosition - 1)
        : Math.min(text.length, cursorPosition + 1);

    setCursorPosition(newPosition);
    updateCursorPosition(newPosition);
  };

  const InputComponent = () => {
    const { ref, focused, focusSelf } = useFocusable({
      onEnterPress,
    });
    const { setMouseFocus } = useInputMode();
    const handleMouseEnter = useCallback(() => {
      setMouseFocus(true);
      focusSelf();
    }, [focusSelf, setMouseFocus]);

    useEffect(() => {
      if (requestInit) focusSelf();
    }, [requestInit]);

    return (
      <Box
        onClick={() => {
          focusSelf();
          if (onEnterPress) onEnterPress();
        }}
        onMouseEnter={handleMouseEnter}
        component="div"
        ref={ref}
        sx={{
          border: focused
            ? FOCUS_BORDER.active
            : FOCUS_BORDER.inactive,
          display: "flex",
          cursor: "text",
          alignItems: "center",
          width: "100%",
          background: "var(--gray-10, #262626)",
          borderRadius: "20px",
          direction: "rtl", // For proper Persian text alignment
          position: "relative",
          p: 2,
          pr: 3,
        }}
      >
        <Box
          ref={textRef}
          contentEditable={false} // Ensure text isn't user-editable directly
          sx={{
            ml: 1,
            flex: 1,
            color: text ? "whitesmoke" : "#B3B3B3",
            fontWeight: "600",
            fontSize: "24px",
            whiteSpace: "pre", // Preserve spaces in the text
            display: "block",
            position: "relative",
            minHeight: "36px",
          }}
        >
          {text || "جستجو کنید..."}
          {/* <span
            style={{
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              right: `${cursorLeft}px`,
              width: "2px",
              height: "24px",
              backgroundColor: "#8C8C8C",
              opacity: showCursor ? 1 : 0,
            }}
          /> */}
        </Box>
        {isLoading && (
          <img
            className="ml-1"
            src="/three-dots.svg"
            alt="loading..."
            width={40}
          />
        )}
      </Box>
    );
  };

  return {
    InputComponent,
    moveCursor,
    addCharacter,
    removeCharacter,
    text,
  };
};

export default useMockInput;
